import Frame from './../Frame';
import applyStyles from "./../dom/applyStyles";
import { ControllerOptions, TrackingOptions } from "../types/SecurionPayOptions";
import { ControllerFrameParams } from "./ControllerFrameParams";
import { getFrameAbsoluteUrl } from '../resourceUrls';

export default class ControllerFrame extends Frame {

    constructor(controllerId, publicKey: string, options: ControllerOptions, tracking: TrackingOptions) {
        const parms: ControllerFrameParams = {
            publicKey,
            jsId: tracking?.jsId
        };
        if (typeof options.merchantId !== "undefined") {
            parms.merchantId = options.merchantId;
        }
        if (typeof options.merchantAccountId !== "undefined") {
            parms.merchantAccountId = options.merchantAccountId;
        }
        if (typeof options.referrer !== "undefined") {
            parms.referrer = options.referrer;
        }
        super(getFrameAbsoluteUrl('controller.html'), controllerId, parms);
    }

    _generateId() {
        return this._controllerId;
    }

    _createIframe(params) {
        let iframe = super._createIframe(params);
        iframe.setAttribute('aria-hidden', 'true');

        let styles = {
            border: "none",
            margin: "0",
            padding: "0",
            width: "1px",
            "min-width": "100%",
            overflow: "hidden",
            display: "block",
            visibility: "hidden",
            position: "fixed",
            height: "1px",
            "pointer-events": "none"
        };

        applyStyles(iframe, styles);

        return iframe;
    }
}